document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-slider]').forEach((slider) => {

    const slides = slider.querySelectorAll('.image-slider__slide');
    const nextButton = slider.querySelector('.image-slider__arrow--next');
    const prevButton = slider.querySelector('.image-slider__arrow--prev');

    if (slides.length <= 1) return;

    let current = 0;

    const showSlide = (index) => {
      slides.forEach((slide) => {
        slide.classList.remove('is-active');
      });

      slides[index].classList.add('is-active');
    };

    nextButton.addEventListener('click', () => {
      current = (current + 1) % slides.length;
      showSlide(current);
    });

    prevButton.addEventListener('click', () => {
      current = (current - 1 + slides.length) % slides.length;
      showSlide(current);
    });
  });
});